// extracted by mini-css-extract-plugin
module.exports = {"box":"box-39yF9uRq","ad":"ad-1XU6S-2V"};